import { render, staticRenderFns } from "./closeNotification.vue?vue&type=template&id=7b45e527&"
import script from "./closeNotification.vue?vue&type=script&lang=js&"
export * from "./closeNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports